//react
import React from "react";
import { Strings } from "../../Resources/Strings/i18n";

//UI components
import "./InvitationModal.scss";
import Button from "@material-ui/core/Button";
import ic_google_play from "../../Resources/Images/ic_google_play.png";
import ic_app_store from "../../Resources/Images/ic_app_store.png";
import ic_web_app from "../../Resources/Images/ic_web_app.png"

var CONNECT_URL;
const openLink = () => {
  window.location.href = CONNECT_URL;
};
export const InvitationModal = ({
  userName,
  installLink,
  loginInvitedUser,
}) => {
  let fullMessage =
    Strings("InvitationInfo1") + userName + "'s" + Strings("InvitationInfo2");
  CONNECT_URL = installLink;
  return (
    <div id="dialog">
      <span className="content">{fullMessage}</span>
      <div className="connectBtns">
        <button
          className="connectButtom"
          href={CONNECT_URL}
          target="_blank"
          onClick={openLink}
        >
          {/* {Strings("InstallApp")} */}
          <div>
            <img src={ic_google_play} alt={ic_google_play} />
          </div>
          <div>
            <img src={ic_app_store} alt={ic_app_store} />
          </div>
          <div>{Strings("InstallApp")}</div>

        </button>
        <Button
          className="connectButtom1"
          variant="contained"
          color="primary"
          type="submit"
          onClick={loginInvitedUser}
        >
           <div>
            <img src={ic_web_app} alt={"ic_web_app"} />
          </div>
          <div>{Strings("OpenWebApp")}</div>
          
        </Button>
      </div>

      <a className="learnMore" href="https://allwellapp.com/" target="_blank">
        {Strings("LearnMore")}
      </a>
    </div>
  );
};
